export const capitalize = (str: string | undefined) => str && str.charAt(0).toUpperCase() + str.slice(1)